import { useMemo } from 'react';
import { DEFAULT_FILTERS } from '../utils/dashboardConstants';

export const buildFilterSearchParams = (filters, overrides = {}) => {
    const merged = { ...filters, ...overrides };
    const params = new URLSearchParams();

    Object.entries(merged).forEach(([key, value]) => {
        const defaultVal = DEFAULT_FILTERS[key];
        if (value === null || value === '' || value === defaultVal) return;
        params.set(key, String(value));
    });

    const query = params.toString();
    return query ? `?${query}` : '';
};

export const useApiFilters = (filters, debouncedFields = {}) => useMemo(() => ({
    ...filters,
    ...debouncedFields,
}), [filters, debouncedFields]);
